import {
  START_POST_FORM_ROUTINE,
  CLOSE_POST_FORM,
  UPDATE_POST_FORM_FIELD,
  SAVE_POST_FORM_ROUTINE,
  SELECT_POST_FORM_PLATFORM,
  TOGGLE_POST_FORM_PLATFORM_LINK,
  CHECK_INSTAGRAM_POST_OVERLAPPING,
  CHECK_INSTAGRAM_PREFLIGHT,
  SET_POST_FORM_IG_AUDIO_PICKER_OPEN,
} from "../constants/ActionTypes";
import { createAction } from "@reduxjs/toolkit";
import { AccountPlatformType, AccountType } from "../shared/types/accounts";
import type { FormPlatformType } from "../shared/types/post";
import { Post } from "../features/post";
import { StartPostFormSuccessPayload } from "../reducers/types";

// Post - FORM (edit / create)
export const startPostForm = createAction(
  START_POST_FORM_ROUTINE.TRIGGER,
  function prepare(post: Post, accounts: AccountType[]) {
    return {
      payload: {
        post,
        accounts,
      } satisfies StartPostFormSuccessPayload,
    };
  }
);

export const closePostForm = createAction(
  CLOSE_POST_FORM,
  function prepare(postId: string) {
    return {
      payload: {
        postId,
      },
    };
  }
);

export const savePostForm = createAction(
  SAVE_POST_FORM_ROUTINE.TRIGGER,
  function prepare(form) {
    return {
      payload: {
        form,
      },
    };
  }
);

export const updatePostFormField = createAction(
  UPDATE_POST_FORM_FIELD,
  function prepare(
    postId: string,
    values: Record<string, unknown>,
    targetPlatform?: FormPlatformType
  ) {
    return {
      payload: { postId, values, targetPlatform },
    };
  }
);

export const selectPlatform = createAction(
  SELECT_POST_FORM_PLATFORM,
  function prepare(
    platformType: AccountPlatformType,
    postId: string | undefined
  ) {
    return {
      payload: {
        platformType,
        postId,
      },
    };
  }
);

export const checkInstagramPostOverlapping = createAction(
  CHECK_INSTAGRAM_POST_OVERLAPPING.TRIGGER,
  /*
   * `post` is load-bearing and was silently dropped here once already.
   *
   * The saga sends the post's shape so the SERVER can work out whether this
   * publish would reach a phone, which is the only case the 15-minute spacing
   * rule protects. `prepare` listing fields explicitly means a field the callers
   * pass but this signature omits vanishes with no error, and the effect is
   * invisible: the server simply falls back to spacing every account, so the
   * composer keeps warning about clashes the server no longer enforces.
   */
  function prepare({ postId, accounts, isNow, when, post, done }) {
    return {
      payload: {
        postId,
        accounts,
        isNow,
        when,
        post,
        done,
      },
    };
  }
);

export const checkInstagramPreflight = createAction(
  CHECK_INSTAGRAM_PREFLIGHT.TRIGGER,
  function prepare({ postId, accounts, post }) {
    return {
      payload: { postId, accounts, post },
    };
  }
);

export const setIgAudioPickerOpen = createAction(
  SET_POST_FORM_IG_AUDIO_PICKER_OPEN,
  function prepare(postId: string, open: boolean) {
    return {
      payload: { postId, open },
    };
  }
);

export const togglePlatformLink = createAction(
  TOGGLE_POST_FORM_PLATFORM_LINK,
  function prepare(postId?: string) {
    return {
      payload: { postId },
    };
  }
);
